import React from 'react'
import { Link } from 'react-router-dom'

export default function ComparisonListingBanner() {
  return (
    <>
       <section className="Comparison-Listing-banner">
              <img src="/assets/images/cl-banner-bg.webp" alt="Banner" className="img-responsive bg-img" />
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="breadcumb-sec">
                      <ul className='dynamic-breadcrumb'>
                        <li><Link to={"/"}>Home</Link></li>
                        <li><Link to={"/comparison-listing"}>Comparison</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-md-12 col-lg-7">
                    <div className='Comparison-Listing-banner-inner'>
                      <h1 className="heading">Compare. Evaluate. <span>Choose <label className="gradient-color">Mobility Infotech.</label></span></h1>
                      <p>Make confident technology decisions with transparent comparisons of features, integrations, scalability, and logistics capabilities across leading software providers.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
    </>
  )
}
